import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin, CreditCard } from 'lucide-react';

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-slate-900 text-white py-16">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_ecom-growth-hub-4/artifacts/bwt25vdc_logo%20sd%20%288%29%20%281%29.png"
              alt="Obiquiste Solutions"
              className="h-16 w-auto mb-4"
            />
            <p className="text-slate-400 text-sm mb-4">
              Align. Scale. Accelerate.
            </p>
            <p className="text-slate-400 text-sm">
              Full-service e-commerce growth agency helping brands expand across marketplaces.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-400 hover:text-primary transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-400 hover:text-primary transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-primary transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/case-studies" className="text-slate-400 hover:text-primary transition-colors text-sm">
                  Case Studies
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-slate-400 hover:text-primary transition-colors text-sm">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/amazon-account-management-services" className="text-slate-400 hover:text-primary transition-colors text-sm">
                  Amazon Account Management
                </Link>
              </li>
              <li>
                <Link to="/flipkart-account-management-services" className="text-slate-400 hover:text-primary transition-colors text-sm">
                  Flipkart Account Management
                </Link>
              </li>
              <li>
                <Link to="/myntra-account-management-services" className="text-slate-400 hover:text-primary transition-colors text-sm">
                  Myntra Account Management
                </Link>
              </li>
              <li>
                <Link to="/ajio-account-management-services" className="text-slate-400 hover:text-primary transition-colors text-sm">
                  Ajio Account Management
                </Link>
              </li>
              <li>
                <Link to="/quick-commerce-account-management" className="text-slate-400 hover:text-primary transition-colors text-sm">
                  Quick Commerce Services
                </Link>
              </li>
              <li>
                <Link to="/google-business-profile-optimization" className="text-slate-400 hover:text-primary transition-colors text-sm">
                  Google Business Optimization
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-sm">
                <Phone className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <a href="tel:8376008909" className="text-slate-400 hover:text-primary transition-colors">
                  8376008909
                </a>
              </li>
              <li className="flex items-start space-x-3 text-sm">
                <Mail className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <a href="mailto:info@obiquistesolutions.com" className="text-slate-400 hover:text-primary transition-colors">
                  info@obiquistesolutions.com
                </a>
              </li>
            </ul>

            <div className="mt-6">
              <h4 className="font-heading font-semibold text-white mb-3">Follow Us</h4>
              <div className="flex space-x-3">
                <a
                  href="https://www.facebook.com/obiquistesolutions"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="social-facebook"
                  className="w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center hover:bg-[#1877F2] transition-colors"
                >
                  <Facebook size={18} />
                </a>
                <a
                  href="https://www.instagram.com/obiquiste_solutions/"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="social-instagram"
                  className="w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center hover:bg-[#E4405F] transition-colors"
                >
                  <Instagram size={18} />
                </a>
                <a
                  href="https://www.linkedin.com/in/obiquiste-solutions-0b4018185/"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="social-linkedin"
                  className="w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center hover:bg-[#0A66C2] transition-colors"
                >
                  <Linkedin size={18} />
                </a>
              </div>
            </div>

            <div className="mt-6">
              <a
                href="https://pages.razorpay.com/pl_IbC3Zyy9vKMXBT/view"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-4 py-2 bg-[#528FF0] hover:bg-[#3d7ae0] text-white text-sm font-medium rounded-lg transition-colors"
              >
                <CreditCard size={16} className="mr-2" />
                Make a Payment
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} Obiquiste Solutions. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link to="/privacy" className="text-slate-400 hover:text-primary transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-slate-400 hover:text-primary transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;